import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { Row, Col } from 'antd';
import Translate from 'react-translate-component';

import { getToken } from 'utils/token';
import { generateBookFileUrl } from 'constants/urls';
import { getScenarioFileList } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import StaticTable from 'components/common/tableComponents/StaticTable';
import RefreshButton from 'components/common/controls/RefreshButton';
import { DateField } from 'components/common/fields/DateTimeFields';
import { CMD } from 'constants/scenario';

@asyncConnect({ getScenarioFileList: getScenarioFileList.withOptions(fullAutoOptions) })
export default class FileLibraryTable extends Component {
    static propTypes = {
        getScenarioFileList: PropTypes.object.isRequired
    }

    tableColumns = [
        {
            name: 'number',
            width: 60,
            additionalClass: 'p-l-15',
            template: ({ rowIndex }) => rowIndex + 1
        },
        {
            name: 'name',
            width: 300,
            label: <Translate content="education.fileLibrary.name" />,
            template: ({ item: { name, id } }) => (
                <a href={generateBookFileUrl(id, CMD, getToken())} download>{name}</a>
            )
        },
        {
            name: 'state',
            width: 250,
            label: <Translate content="education.scenario.states" />,
            template: ({ item: { state } }) => <Translate content={`education.scenario.state.${state}`} />
        },
        {
            name: 'sentDate',
            width: 80,
            label: <Translate content="education.fileLibrary.sentDate" />,
            template: ({ item: { sentDate } }) => <DateField date={sentDate} />
        }
    ]

    render() {
        const { meta, data, refresh } = this.props.getScenarioFileList;

        return (
            <div className="file-library">
                <Row className="react-table-controls list-controls">
                    <Col span={24} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <StaticTable
                    meta={meta}
                    items={data}
                    refresh={refresh}
                    className="width-auto-table"
                    columns={this.tableColumns}
                />
            </div>
        )
    }
}
